$(() => {
  const scrollDownToSection = () => {
    const url = window.location.href;
    if (url.includes('/?_resource_type=')) {
      const targetSection = $('.resource-library');
      if (targetSection.length) {
        $('html, body').animate(
          {
            scrollTop: targetSection.offset().top - 100,
          },
          800
        );
      }
    }
  };
  $(document).ready(function () {
    scrollDownToSection();
  });
});
